(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-moments"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cmoments__track').forEach(function (t) {
  var down = false, startX = 0, start = 0, moved = false;
  t.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; start = t.scrollLeft; });
  window.addEventListener('mouseup', function () { down = false; t.classList.remove('is-drag'); });
  t.addEventListener('mousemove', function (e) {
    if (!down) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) { moved = true; t.classList.add('is-drag'); }
    t.scrollLeft = start - dx;
  });
  t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  if (e.target.closest('[data-menu-open]')) { document.documentElement.classList.add('noxa-menu-open'); }
  if (e.target.closest('[data-menu-close]')) { document.documentElement.classList.remove('noxa-menu-open'); }
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') { document.documentElement.classList.remove('noxa-menu-open'); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-premium"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.nxh'); if(!root) return;
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    root.querySelectorAll('[data-reveal]').forEach(function(el){io.observe(el);});
    var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){anim(e.target);cio.unobserve(e.target);}})},{threshold:.5});
    root.querySelectorAll('[data-count]').forEach(function(c){cio.observe(c);});
  } else {
    root.querySelectorAll('[data-reveal]').forEach(function(el){el.classList.add('in');});
  }
  function anim(el){
    var target=parseFloat(el.getAttribute('data-count'));
    var dec=parseInt(el.getAttribute('data-decimals')||'0',10);
    var suf=el.getAttribute('data-suffix')||'';
    var t0=null,dur=1500;
    function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1);var v=target*(1-Math.pow(1-p,3));el.textContent=(dec?v.toFixed(dec).replace('.',','):Math.round(v).toLocaleString('de-DE'))+suf;if(p<1)requestAnimationFrame(step);}
    requestAnimationFrame(step);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Bug 1 : clic sur une vignette -> remplace l'image principale.
     Délégation sur document = robuste, fonctionne quel que soit le timing de chargement. */
  function swapMainImage(thumb) {
    var gal = thumb.closest('[data-noxa-gallery]');
    if (!gal) return;
    var mainImg = gal.querySelector('[data-gal-main] img');
    var src = thumb.getAttribute('data-src');
    if (mainImg && src) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
    }
    gal.querySelectorAll('[data-gal-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gal-thumb]');
    if (thumb) { e.preventDefault(); swapMainImage(thumb); }
  });

  function initNoxaGalleries(root) {
    (root || document).querySelectorAll('[data-noxa-gallery]').forEach(function (gal) {
      if (gal.dataset.ngInit) return;
      gal.dataset.ngInit = '1';
      var style = gal.getAttribute('data-style') || 'thumbs';
      if (style === 'scroll') { initScrollGal(gal); }
      else if (style === 'rotative') { initRotativeGal(gal); }
    });
  }

  function initScrollGal(gal) {
    var track = gal.querySelector('[data-gal-track]');
    var dots = gal.querySelectorAll('[data-gal-dot]');
    if (!track || !dots.length) return;
    track.addEventListener('scroll', function () {
      var slides = track.children;
      if (!slides.length) return;
      var sw = slides[0].offsetWidth + 10;
      var idx = Math.round(track.scrollLeft / sw);
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  }

  function initRotativeGal(gal) {
    var slides = gal.querySelectorAll('[data-gal-slide]');
    if (slides.length < 2) return;
    var spd = (parseInt(gal.getAttribute('data-speed'), 10) || 3) * 1000;
    var cur = 0;
    var timer;

    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === cur); });
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(cur + 1); }, spd);
    }

    show(0);
    restart();

    var prev = gal.querySelector('[data-gal-prev]');
    var next = gal.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(cur + 1); restart(); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () { initNoxaGalleries(document); });
  document.addEventListener('shopify:section:load', function (e) { initNoxaGalleries(e.target); });
})();

/* ===== Sélecteur de variantes : sélection + prix + bouton + changement d'image ===== */
(function () {
  function parseVariants(form) {
    var el = form.querySelector('[data-variant-json]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function baseName(u) {
    if (!u) return '';
    u = ('' + u).split('?')[0];
    u = u.substring(u.lastIndexOf('/') + 1);
    u = u.replace(/_(\d+)x(\d+)?(\.[a-zA-Z0-9]+)$/, '$3');
    return u;
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function selectedValues(form) {
    var vals = [];
    form.querySelectorAll('[data-option-row]').forEach(function (row) {
      var act = row.querySelector('[data-variant-swatch].is-active');
      vals.push(act ? act.getAttribute('data-value') : null);
    });
    return vals;
  }
  function findVariant(variants, vals) {
    for (var n = 0; n < variants.length; n++) {
      var v = variants[n], ok = true;
      for (var i = 0; i < vals.length; i++) {
        if (vals[i] == null) continue;
        if (v.options[i] !== vals[i]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function showVariantImage(gal, src) {
    if (!gal || !src) return;
    var want = baseName(src);
    var thumbs = gal.querySelectorAll('[data-gal-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      if (baseName(thumbs[i].getAttribute('data-src')) === want) { thumbs[i].click(); return; }
    }
    var rslides = gal.querySelectorAll('[data-gal-slide]');
    for (var k = 0; k < rslides.length; k++) {
      var im2 = rslides[k].querySelector('img');
      if (im2 && baseName(im2.src) === want) {
        rslides.forEach(function (s) { s.classList.remove('is-active'); });
        rslides[k].classList.add('is-active'); return;
      }
    }
    var track = gal.querySelector('[data-gal-track]');
    if (track) {
      var sl = track.children;
      for (var j = 0; j < sl.length; j++) {
        var im = sl[j].querySelector('img');
        if (im && baseName(im.src) === want) { sl[j].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); return; }
      }
    }
    var mainImg = gal.querySelector('[data-gal-main] img');
    if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = src; }
  }
  function updateInfo(form, v) {
    var root = form.closest('.noxa-pdp__info') || document;
    var priceEl = root.querySelector('.noxa-pdp__price');
    var cmpEl = root.querySelector('.noxa-pdp__compare');
    var discEl = root.querySelector('.noxa-pdp__discount');
    var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
    if (priceEl) priceEl.textContent = money(v.price);
    if (cmpEl) { cmpEl.textContent = hasCmp ? money(v.compare_at_price) : ''; cmpEl.style.display = hasCmp ? '' : 'none'; }
    if (discEl) {
      if (hasCmp) { discEl.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; discEl.style.display = ''; }
      else { discEl.style.display = 'none'; }
    }
    var atc = root.querySelector('.noxa-pdp__atc');
    if (atc) {
      var lbl = atc.getAttribute('data-atc-label') || 'In den Warenkorb';
      var sold = atc.getAttribute('data-soldout-label') || 'Ausverkauft';
      var showP = atc.getAttribute('data-show-price') !== 'false';
      if (v.available) { atc.removeAttribute('disabled'); atc.textContent = showP ? (lbl + ' · ' + money(v.price)) : lbl; }
      else { atc.setAttribute('disabled', 'disabled'); atc.textContent = sold; }
    }
  }
  function onPick(form, sw) {
    var row = sw.closest('[data-option-row]');
    if (row) {
      row.querySelectorAll('[data-variant-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var lab = row.querySelector('[data-variant-label]');
      if (lab) lab.textContent = sw.getAttribute('data-value');
    }
    var variants = parseVariants(form);
    var v = findVariant(variants, selectedValues(form));
    if (!v) return;
    var sel = form.querySelector('[data-variant-select]');
    if (sel) { sel.value = v.id; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    updateInfo(form, v);
    var gal = document.querySelector('[data-noxa-gallery]');
    var src = (v.featured_image && v.featured_image.src) ? v.featured_image.src : (sw.getAttribute('data-variant-img') || '');
    if (src) showVariantImage(gal, src);
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-variant-swatch]');
    if (!sw) return;
    var form = sw.closest('form');
    if (!form) return;
    e.preventDefault();
    onPick(form, sw);
  });
})();

/* Compteur du champ de personnalisation. Pas de dépendance, pas de framework. */
(function () {
  var input = document.querySelector('[data-perso-input]');
  var out = document.querySelector('[data-perso-count]');
  if (!input || !out) return;
  var max = input.getAttribute('maxlength') || '';
  function maj() { out.textContent = input.value.length + '/' + max; }
  input.addEventListener('input', maj);
  maj();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxh-base"] && !Shopify.designMode) return;
  try {
    
(function(){
  var D=document, W=window;
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = W.Shopify && W.Shopify.designMode;
  function anim(el){var t=parseFloat(el.getAttribute('data-count'))||0,d=parseInt(el.getAttribute('data-decimals')||'0',10),s=el.getAttribute('data-suffix')||'',t0=null;function st(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/1500,1),v=t*(1-Math.pow(1-p,3));el.textContent=(d?v.toFixed(d).replace('.',','):Math.round(v).toLocaleString('de-DE'))+s;if(p<1)requestAnimationFrame(st);}requestAnimationFrame(st);}
  function showAll(root){(root||D).querySelectorAll('.nxh [data-reveal]').forEach(function(el){el.classList.add('in');});}
  function countAll(root){(root||D).querySelectorAll('.nxh [data-count]').forEach(anim);}
  function ready(fn){if(D.readyState!=='loading')fn();else D.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    if(design || reduce || !('IntersectionObserver' in W)){
      // Editor / no-JS-anim / reduced motion: show everything, never hide (fixes vanishing sections on edit).
      showAll(); countAll();
    } else {
      D.documentElement.classList.add('nxh-rv'); // enable the hidden state only now (safe)
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
      D.querySelectorAll('.nxh [data-reveal]').forEach(function(el){io.observe(el);});
      var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){anim(e.target);cio.unobserve(e.target);}})},{threshold:.5});
      D.querySelectorAll('.nxh [data-count]').forEach(function(c){cio.observe(c);});
    }
    // Theme editor: whenever a section is (re)rendered after an edit, immediately reveal it.
    D.addEventListener('shopify:section:load', function(e){ showAll(e.target); countAll(e.target); });
    D.addEventListener('shopify:section:select', function(e){ showAll(e.target); });
    // Safety net: if anything in the viewport is still hidden after 3s, reveal it.
    setTimeout(function(){
      D.querySelectorAll('.nxh [data-reveal]:not(.in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < W.innerHeight + 100 && r.bottom > -100) { el.classList.add('in'); }
      });
    }, 3000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxh-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function animate(el){
    var to=parseFloat(el.getAttribute('data-to'))||0,suf=el.getAttribute('data-suffix')||'',dec=parseInt(el.getAttribute('data-dec')||'0',10),dur=1500,start=null;
    function step(t){if(!start)start=t;var p=Math.min((t-start)/dur,1),e=1-Math.pow(1-p,3);el.textContent=(to*e).toFixed(dec).replace('.',',')+suf;if(p<1)requestAnimationFrame(step);else el.textContent=to.toFixed(dec).replace('.',',')+suf;}
    requestAnimationFrame(step);
  }
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var nums=document.querySelectorAll('.nx-banner .nx-num');
    if(window.Shopify&&window.Shopify.designMode||!('IntersectionObserver' in window)){nums.forEach(animate);return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){animate(e.target);io.unobserve(e.target);}})},{threshold:.4});
    nums.forEach(function(n){io.observe(n);});
    document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('.nx-num').forEach(animate);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-reviews-more]');
  if (!btn) return;
  var section = btn.closest('.noxa-section');
  if (!section) return;
  var hidden = section.querySelectorAll('.noxa-review--hidden');
  for (var i = 0; i < hidden.length; i++) {
    hidden[i].classList.remove('noxa-review--hidden');
  }
  var wrap = btn.closest('.noxa-reviews__more-wrap');
  if (wrap) wrap.style.display = 'none';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var d = document, root = d.documentElement;
  root.classList.add('reveal-on');
  function run() {
    var els = d.querySelectorAll('.noxa-section');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (d.readyState !== 'loading') { run(); } else { d.addEventListener('DOMContentLoaded', run); }
})();

  } catch(e) { console.error(e); }
})();
})();
